import noop from 'lodash/noop';
import PropTypes from 'prop-types';

export const propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      action: PropTypes.func.isRequired,
      text: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string]).isRequired,
  cancelText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  closeText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  cancelButton: PropTypes.bool,
  closeButton: PropTypes.bool,
  cancelType: PropTypes.string,
  locked: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.number,
  valid: PropTypes.bool,
  edited: PropTypes.bool,

  // Methods
  close: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
};

export const defaultProps = {
  buttons: [],
  cancelText: 'Cancel',
  closeText: 'OK',
  cancelButton: true,
  closeButton: true,
  cancelType: 'default',
  locked: false,
  title: '',
  type: '',
  useCloseAction: false,
  useCancelAction: false,
  valid: true,
  edited: false,

  // Methods
  close: noop,
  showModal: noop,
  onCancel: noop,
  onClose: noop,
};
